import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorShippingRoute = v.object({
  name: v.string(),
  branchOriginId: v.id("branches"),
  branchDestinationId: v.id("branches"),
  estimatedDays: v.number(),
  isActive: v.boolean(),
  notes: v.optional(v.string()),
  internalControl: internalControl,
});

export const shipping_routes = defineTable(validatorShippingRoute)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_is_active", ["isActive"])
  .index("by_origin", ["branchOriginId"])
  .index("by_destination", ["branchDestinationId"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .index("by_company_and_origin", [
    "internalControl.companyId",
    "branchOriginId",
  ])
  .index("by_company_and_destination", [
    "internalControl.companyId",
    "branchDestinationId",
  ])
  .searchIndex("search_shipping_routes", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "isActive",
    ],
  });
